<template>
  <div class="columns is-centered">
    <div class="column is-9">
      <div class="content">
        <page-title>{{ $t('project.staticPages.montage.title') }}</page-title>
        <template v-if="project === 'schuette'">
          <!-- <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/LlUYqo_Mc-Y"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>

          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/99m8OrBSgnc"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>

          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/YWSDk-9WWfI"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure> -->
          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/afz9k9xz2RY"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>

          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/hzdMGeDAFMY"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>

          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/7MUeN_GCq24"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>

          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/3w2yJR3QdXA"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>

          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/KBkTAF_Kp2M"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>
        </template>
        <template v-if="project === 'rzaska'">
          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/9Sfk3c1s9B4"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>

          <figure class="image is-16by9">
            <iframe
              class="has-ratio"
              width="640"
              height="360"
              src="https://www.youtube.com/embed/0-0KaEAP9sI"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </figure>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  layout: 'page',
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      titleTemplate: '%s',
      title: this.$t('project.seo.montage.title'),
      meta: [
        ...i18nHead.meta,
        { hid: 'description', name: 'description', content: this.$t('project.seo.montage.description') }
      ],
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      link: [
        ...this.metaLink(i18nHead.link)
      ]
    }
  }
}
</script>
